import { render, staticRenderFns } from "./PrivateVideo.vue?vue&type=template&id=6bd7e1b2&"
import script from "./PrivateVideo.vue?vue&type=script&lang=ts&"
export * from "./PrivateVideo.vue?vue&type=script&lang=ts&"
import style0 from "./PrivateVideo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports